import React from 'react'
import get from 'lodash/get'

import { ROLES } from 'config'
import { clientTabs } from 'config/data'
import { getRoleFromPath, navigateTo } from 'utils/helper'
import TackleAvatarLogo from 'components/Common/TackleAvatarLogo'

import {
  LogoWrapper,
  ClientWrapper,
  TopGoalWrapper,
  GoalTextWrapper,
  GoalInfoWrapper,
  BusinessNameWrapper,
  BusinessTextWrapper,
  BusinessInfoWrapper,
  MobileClientWrapper,
  ActiveClientWrapper,
  CommunicationWrapper,
  HorizontalBreakWrapper,
  MobileClientInfoWrapper,
  MobileClientIconWrapper,
  CommunicationIconWrapper,
  MobileBusinessNameWrapper,
  MobileActiveClientWrapper,
  MobileActiveClientCardWrapper,
  NavigateToClientDetailWrapper,
  StyledCommunicationIconWrapper,
  MobileCommunicationIconWrapper,
  MobileNavigateToClientDetailWrapper,
  MobileStyledCommunicationIconWrapper,
} from 'components/Clients/ActiveClientCard/style'

const ActiveClientCard = ({ isMobile = false, client, index }) => {
  const userRole = getRoleFromPath()

  // Define avatar background colors based on Figma design
  const avatarColors = [
    'bg-purple-lighter2x', // Light purple for first client (Patty Pearl)
    'bg-orange-light', // Light orange for second client (Peter Puff)
    'bg-green-lighter2x', // Light green for third client (Teresa Peacock)
  ]

  // Define text colors to match background colors
  const textColors = [
    'text-purple-lighter1x', // Purple text for purple background
    'text-orange', // Orange text for orange background
    'text-green-dark', // Green text for green background
  ]

  const avatarColor = avatarColors[index % avatarColors.length] || 'bg-blue-lighter1x'
  const textColor = textColors[index % textColors.length] || 'text-white'

  const naviagateToClientDetailPageHandler = (client) => {
    if (window.location?.href?.includes('advisor')) {
      navigateTo(ROLES.BSO_ADVISOR, `clients/${client?.id}/${clientTabs[0].name}`)
    } else {
      navigateTo(ROLES.BSO_ADMIN, `clients/${client?.id}/${clientTabs[0].name}`)
    }
  }

  return (
    <>
      {!isMobile ? (
        <ActiveClientWrapper>
          <CommunicationIconWrapper onClick={() => navigateTo(userRole, `chat/${client?.id}`)}>
            <StyledCommunicationIconWrapper />
          </CommunicationIconWrapper>

          <ClientWrapper>
            <LogoWrapper onClick={() => naviagateToClientDetailPageHandler(client)}>
              <TackleAvatarLogo
                logo={client?.logo?.url}
                firstName={client.firstName}
                lastName={client.lastName}
                textSize="text-4xl mdl:text-3xl xl:text-4xl"
                textColor={textColor}
                className={`${avatarColor} h-[100px] w-[100px] mdl:h-[80px] mdl:w-[80px] xl:h-[120px] xl:w-[120px]`}
              />
            </LogoWrapper>

            <NavigateToClientDetailWrapper
              onClick={() => naviagateToClientDetailPageHandler(client)}
            >
              {client.firstName && client.lastName ? (
                `${client.firstName} ${client.lastName}`
              ) : (
                <span>&nbsp;&nbsp;</span>
              )}
            </NavigateToClientDetailWrapper>
          </ClientWrapper>

          <BusinessInfoWrapper>
            <BusinessTextWrapper>Business</BusinessTextWrapper>
            <BusinessNameWrapper> {get(client, 'businessName', '')} </BusinessNameWrapper>
          </BusinessInfoWrapper>
          <HorizontalBreakWrapper />
          <GoalInfoWrapper>
            <GoalTextWrapper>Top Goal</GoalTextWrapper>
            <TopGoalWrapper>{get(client, 'topGoal', '')}</TopGoalWrapper>
          </GoalInfoWrapper>
        </ActiveClientWrapper>
      ) : (
        <MobileActiveClientWrapper key={index}>
          <MobileClientWrapper>
            <MobileClientInfoWrapper>
              <MobileClientIconWrapper>
                <span onClick={() => naviagateToClientDetailPageHandler(client)}>
                  <TackleAvatarLogo
                    firstName={client.firstName}
                    lastName={client.lastName}
                    textSize="text-2xl"
                    textColor={textColor}
                    className={`${avatarColor} h-[54px] w-[54px] rounded-full`}
                  />
                </span>
              </MobileClientIconWrapper>

              <MobileActiveClientCardWrapper>
                <div>
                  <MobileNavigateToClientDetailWrapper
                    onClick={() => naviagateToClientDetailPageHandler(client)}
                  >
                    {client.firstName && client.lastName ? (
                      `${client.firstName} ${client.lastName}`
                    ) : (
                      <span>&nbsp;&nbsp;</span>
                    )}
                  </MobileNavigateToClientDetailWrapper>
                </div>
                <div>
                  <MobileBusinessNameWrapper>
                    {' '}
                    {get(client, 'businessName', '')}
                  </MobileBusinessNameWrapper>
                </div>
              </MobileActiveClientCardWrapper>
            </MobileClientInfoWrapper>

            <CommunicationWrapper>
              <MobileCommunicationIconWrapper
                onClick={() => navigateTo(userRole, `chat/${client?.id}`)}
              >
                <MobileStyledCommunicationIconWrapper />
              </MobileCommunicationIconWrapper>
              <GoalInfoWrapper>
                <TopGoalWrapper>{get(client, 'topGoal', '')}</TopGoalWrapper>
              </GoalInfoWrapper>
            </CommunicationWrapper>
          </MobileClientWrapper>
        </MobileActiveClientWrapper>
      )}
    </>
  )
}

export default ActiveClientCard
